@if (isHealthcheck) {
  <div
    style="
      background-color: #00c853;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      width: 100vw;
      margin: 0;
    ">
    <h1 style="color: white; font-family: sans-serif; font-size: 48px">ok</h1>
  </div>
} @else {
  <mat-drawer-container autosize>
    <mat-drawer
      mode="side"
      opened>
      <div class="menu">
        <ul class="menu">
          <li class="logo">
            <img src="assets/icons/icon-logo.svg" />
          </li>
          @for (item of menu | menuPermissions; track item) {
            <li
              class="item-menu"
              routerLinkActive="active"
              [routerLink]="item.url"
              [appTooltip]="item.label"
              tooltipPosition="right">
              <mat-icon>{{ item.icon }}</mat-icon>
            </li>
          }
        </ul>

        <ul class="menu bottom-menu">
          @if (isSeasonActive()) {
            <li
              class="item-menu"
              (click)="menuShowMode()?.onClick()">
              <img src="./assets/images/snow/icon-{{ menuShowMode()?.icon }}.svg" />
            </li>
          }
          @for (item of bottomMenu; track item.icon) {
            <li
              class="item-menu"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: item.exact }"
              [routerLink]="item.route ? ['./' + item.route] : null"
              [appTooltip]="item.label"
              tooltipPosition="right"
              (click)="!item.route && logout()">
              <mat-icon>{{ item.icon }}</mat-icon>
            </li>
          }
        </ul>

        <p
          class="release"
          (click)="snoopToggle()">
          v0.24.0
        </p>
      </div>
    </mat-drawer>

    <mat-drawer-content id="spinner-container">
      <section class="main">
        <router-outlet></router-outlet>
      </section>

      <div class="snoop-container">
        <img
          [class.snoop-swag-show]="snoopStatus"
          src="./assets/images/{{ isSeasonActive() ? 'snoop-dogg-santa' : 'snoop' }}.gif" />
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
}
